/**
 * Monta o texto do QR code no mesmo formato usado no fluxo de venda.
 * Espera objeto com: transactionId, value, pagbank, partner { name, document }.
 * Formato: mode=online&transactionId&document&name(encoded)&value&pagbank
 */
export const buildTransactionQRCodeText = (data: {
  transactionId?: string;
  value?: number | string;
  pagbank?: boolean;
  partner?: { name?: string; document?: string };
  qrcode?: string;
}): string => {
  if (data.partner && data.transactionId) {
    const partnerName = data.partner.name
      ? encodeURIComponent(data.partner.name)
      : "";
    const partnerDocument = data.partner.document || "";
    const value = data.value ?? 0;
    const pagbankFlag =
      typeof data.pagbank === "boolean" ? data.pagbank : !!data.pagbank;
    return `mode=online&${data.transactionId}&${partnerDocument}&${partnerName}&${value}&${pagbankFlag}`;
  }
  return data.qrcode || "";
};

/**
 * Monta o texto do QR code estático (configurações do parceiro).
 * Mesmo formato do online, mas mode=static e sem valor (penúltimo campo).
 * Formato: mode=static&partnerId&document&name(encoded)&pagbank
 */
export const buildStaticQRCodeText = (data: {
  partnerId: string;
  document: string;
  name: string;
  pagbank?: boolean;
}): string => {
  const partnerName = data.name ? encodeURIComponent(data.name) : "";
  const pagbankFlag =
    typeof data.pagbank === "boolean" ? data.pagbank : true;
  return `mode=static&${data.partnerId}&${data.document}&${partnerName}&${pagbankFlag}`;
};
